import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'lib-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DateRangePickerComponent implements OnInit {
  @Input() availableFrom: FormControl;
  @Input() availableTo: FormControl;
  @Input() checkboxLabel: string;
  @Input() infoKey: string;
  @Input() showAvailableToOnStart = true;
  // When true, the checkbox semantics are inverted: a checked box means the "to" date IS shown
  // (e.g. "This is a temporary room"), rather than the default "always available" meaning.
  @Input() invertCheckbox = false;
  @ContentChild('from') from!: TemplateRef<any>;
  @ContentChild('to') to!: TemplateRef<any>;
  @Output() toDateVisible = new EventEmitter<boolean>();

  showAvailableTo = true;

  ngOnInit(): void {
    this.showAvailableTo = this.invertCheckbox ? !this.showAvailableToOnStart : this.showAvailableToOnStart;
  }

  checkboxToggled(value: boolean) {
    this.toDateVisible.emit(this.invertCheckbox ? value : !value);
  }
}
